import React from "react";
import "../../styles/ExportButtons.css";

const ExportButtons = () => {

    return (

        <div className="report-card">

            <h3>

                Export Reports

            </h3>

            <div className="export-buttons">

                <button>

                    Export PDF

                </button>

                <button>

                    Export Excel

                </button>

                <button>

                    Export CSV

                </button>

            </div>

        </div>

    );

};

export default ExportButtons;